// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Кампанії» (Campaigns, ключ `cmp`, група `party-and-group`). */
export const campaignsManifest: IModuleManifest = {
  key: 'cmp',
  group: 'party-and-group',
  slug: 'campaigns',
  prefix: 'CMP',
  name: { en: 'Campaigns', uk: 'Кампанії' },
  entities: [
    { key: 'cmp', slug: 'cmp', name: { en: 'Campaigns', uk: 'Кампанії' }, main: true },
    { key: 'vol', slug: 'vol', name: { en: 'Volunteers', uk: 'Волонтери' }, main: false },
    { key: 'campaign_candidate', slug: 'campaign-candidate', name: { en: 'Campaign Candidates', uk: 'Кандидати' }, main: false },
    { key: 'campaign_activity', slug: 'campaign-activity', name: { en: 'Campaign Activities', uk: 'Заходи' }, main: false },
    { key: 'campaign_result', slug: 'campaign-result', name: { en: 'Campaign Results', uk: 'Результати' }, main: false },
  ],
  loadState: () => import('./state/campaignsSlice').then((m) => m.campaignsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
